import React from 'react';
import {Table} from "antd";

const TableComponent = ({dataSource, columns}) => {
    return (
        <Table
            dataSource={dataSource}
            columns={columns}
            size="small"    // large | middle | small 对应不同的表格宽度
            // 表头冻结，纵向高度 550px
            scroll={{x: true, y: 550}}
            responsive={true}
            onChange={
                pagination => sessionStorage.setItem("currentPage", pagination.current.toString())
            }
            pagination={{defaultCurrent: parseInt(sessionStorage.getItem("currentPage"))}}
        />
    );
};

export default TableComponent;


